import React from 'react';
import { Grid, Box, Paper, Card, CardMedia, Typography } from '@mui/material';

import CONFIG from '../../../config/config.js'
const WINE_IMAGE_SERVER_IP = CONFIG.WINE_IMAGE_SERVER_IP
const WINE_IMAGE_SERVER_URL = CONFIG.WINE_IMAGE_SERVER_URL



import { PAGE_CONSTANT_STYLES } from '../page-constants.jsx'
const MODAL_BACKGROUND_COLOR = PAGE_CONSTANT_STYLES.modal_background_color
const MODAL_INDICATOR_FULL_COLOR = PAGE_CONSTANT_STYLES.modal_indicator_full_color
const MODAL_INDICATOR_EMPTY_COLOR = PAGE_CONSTANT_STYLES.modal_indicator_empty_color
const MODAL_BUTTON_COLOR = PAGE_CONSTANT_STYLES.modal_button_color
const PAGE_BUTTON_TEXT_COLOR = PAGE_CONSTANT_STYLES.page_button_text_color



const ModalContents = (props) => {

    // Extract data from props
    const { data } = props;
    const { onRequestClose } = props;

    const wineDetails = props.data;

    const imgURL = WINE_IMAGE_SERVER_IP + WINE_IMAGE_SERVER_URL + data.image



    function closeModal() {
        onRequestClose()
    }

















    let tastingNotesArray = []

    function parseString(inputString) {
        // Split the input string using comma as the delimiter
        // if (inputString){
        const parts = inputString.split(',');

        // Trim spaces at the beginning of each part
        const trimmedParts = parts.map(part => part.trim());

        // Return the resulting array
        return trimmedParts;
        // }
        // else{
        //     return ['none']
        // }
    }

    tastingNotesArray = parseString(wineDetails.varietal_descriptors);
    ////console.log("tastingNotesArray ", tastingNotesArray);


    // let light_bold_percent = (wineDetails.light_bold / 5) * 100
    // let smooth_tannic_percent = (wineDetails.smooth_tannic / 5) * 100
    // let dry_sweet_percent = (wineDetails.dry_sweet / 5) * 100
    // let soft_acidic_percent = (wineDetails.soft_acidic / 5) * 100

    // let scorePercentObject = {
    //     light_bold: light_bold_percent.toString() + '%',
    //     smooth_tannic: smooth_tannic_percent.toString() + '%',
    //     dry_sweet: dry_sweet_percent.toString() + '%',
    //     soft_acidic: soft_acidic_percent.toString() + '%',
    // }

    let light_bold_percent = (wineDetails.body_light_full / 5) * 100
    let smooth_tannic_percent = (wineDetails.tannin_low_high / 5) * 100
    let dry_sweet_percent = (wineDetails.dry_sweet / 5) * 100
    let soft_acidic_percent = (wineDetails.acid_low_high / 5) * 100

    let scorePercentObject = {
        body_light_full: light_bold_percent.toString() + '%',
        tannin_low_high: smooth_tannic_percent.toString() + '%',
        dry_sweet: dry_sweet_percent.toString() + '%',
        acid_low_high: soft_acidic_percent.toString() + '%',
    }












































    return (
        <div
            style={{
                width: '18rem',
                minHeight: '35rem',
                height: '100%',
                opacity: '100%',
                backgroundColor: MODAL_BACKGROUND_COLOR,
                // backgroundColor: '#edece8', //'#ccdde8', edece8
                border: '0px',
                margin: '0rem',
                padding: '10px',
            }}
        >







            <style>{`
        .graph-container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .graph-row {
          display: flex;
          align-items: center;
          margin-bottom: 0px;
          margin-top: 0px;
          margin-right: 0px;
          margin-left: 0px;
        }

        .graph-bar {
          width: 8rem;
          height: 8px;
          background-color: ${MODAL_INDICATOR_EMPTY_COLOR};
          border-radius: 3px;
          margin-left: 0px;
        }

        .graph-bar::before {
          content: "";
          display: block;
          height: 100%;
          background-color: ${MODAL_INDICATOR_FULL_COLOR};
          border-radius: 3px;
          width: var(--progress);
          transition: width 0.3s ease-in-out;
        }
      `}</style>







            {/* <Typography

                sx={{
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    color: 'black',
                    paddingBottom: '0.5rem',
                    paddingTop: '0rem',
                    paddingLeft: '0rem',
                    paddingRight: '0rem',


                }}
            >{data.name}</Typography>

            <Box
                sx={{
                    position: "absolute",
                    padding: '0rem',
                    backgroundColor: 'gray',
                    width: '9rem',
                    height: '27rem',
                    //paddingBottom: '12px',
                    backgroundImage: `url(${imgURL})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backdropFilter: 'blur(1px)', // Adjust the blur amount as needed
                    opacity: 1, // Adjust the opacity to control the intensity of the background
                    minHeight: '10rem',
                    animation: 'fade-in 0.3s forwards',
                    animationDelay: '0s', // Adjust the delay as needed

                    paddingBottom: '1rem',
                    paddingTop: '0rem',
                    paddingLeft: '0rem',
                    paddingRight: '0rem',


                }}
            >
            </Box> */}
































            {/* <div style={{
                textAlign: 'center',
                padding: '0rem',
            }}>
                <Typography

                    // noWrap={boolTrue}

                    sx={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        color: 'black',
                        paddingBottom: '0.5rem',
                        paddingTop: '0rem',
                        paddingLeft: '0rem',
                        paddingRight: '0rem',


                    }}
                >{wineDetails.name}</Typography>
            </div> */}



            <div
                style={{
                    //height: '100%',
                    //minHeight: '1300px',
                    //width: '100%',//'60rem',
                    margin: '0px',
                }}
            >



                {/* <Typography sx={{ fontSize: '1.1rem', fontWeight: 'bold', }}>TYPE: {wineDetails.type}</Typography>
                            <Typography sx={{ fontSize: '1.1rem', fontWeight: 'bold', }}>GRAPE: {wineDetails.grape}</Typography>
                            <Typography sx={{ fontSize: '1.1rem', fontWeight: 'bold', }}>LOCATION: {wineDetails.region}</Typography>
                            <Typography sx={{ fontSize: '1.1rem', fontWeight: 'bold', }}>REGION: {wineDetails.subregion} </Typography> */}



                {/*                             
                            <p><span style={{ fontWeight: 'bold', }}>TYPE:</span> {wineDetails.type}</p>
                            <p><span style={{ fontWeight: 'bold', }}>GRAPE:</span> {wineDetails.grape}</p>
                            <p><span style={{ fontWeight: 'bold', }}>LOCATION:</span> {wineDetails.subregion} {wineDetails.region}</p>
 */}

            </div>





            <div
                style={{
                    display: "flex",
                    flexDirection: 'row',
                    height: '35rem',
                    paddingBottom: '1rem',
                    paddingTop: '0rem',
                    paddingLeft: '0rem',
                    paddingRight: '0rem',
                }}>


                <div
                    style={{
                        padding: '0rem',
                        margin: '0rem',
                        width: '100%',
                        // backgroundColor: '#fff',
                    }}>


                    {/* 
                                <LazyLoadImage
                                    src={imgURL}
                                    align="center"
                                    // width={112}
                                    // height={200}
                                    style={{
                                        paddingTop: '0rem',
                                        paddingLeft: '0rem',
                                        paddingRight: '1rem',
                                        paddingBottom: '0rem',
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                    }}
                                    alt="Image Alt"
                                />
 */}

                    <Box sx={{
                        //position: "absolute",
                        backgroundColor: '#034488',
                        padding: '0px',
                        width: '100%', //'9rem',
                        height: '27rem',
                        margin: '0px',
                    }}
                    >
                        <Box
                            sx={{
                                //position: "absolute",
                                padding: '0rem',
                                backgroundColor: MODAL_BACKGROUND_COLOR,//'white',
                                width: '100%',
                                height: '35rem',
                                border: '5px',
                                borderColor: 'black',
                                //paddingBottom: '12px',
                                backgroundImage: `url(${imgURL})`,
                                backgroundSize: 'contain', // 'cover',
                                backgroundRepeat: 'no-repeat', 
                                backgroundPosition: 'center',
                                // backdropFilter: 'blur(1px)', // Adjust the blur amount as needed
                                // opacity: 0.8, // Adjust the opacity to control the intensity of the background
                                minHeight: '10rem',
                                animation: 'fade-in 0.3s forwards',
                                animationDelay: '0s', // Adjust the delay as needed

                                // paddingBottom: '1rem',
                                // paddingTop: '0rem',
                                // paddingLeft: '0rem',
                                // paddingRight: '0rem',


                            }}
                        >
                        </Box>
                    </Box>


                </div>



            </div>

            {/* <ModalComponentPrice wineDetails={wineDetails}></ModalComponentPrice> */}



            {/* <Typography>
            'We are thrilled to offer Hillside Select, a 100 percent Cabernet Sauvignon sourced from our rugged hillside vineyards in Napa Valley’s Stags Leap District. This release offers classic richness, youthful elegance and texture. The wine introduces itself with alluring, perfumy aromatics followed by flavors of blackberry, cassis, black cherry, dark chocolate, smoke, peppery spice and a touch of vanilla. The tannins are ripe and refined, holding out great promise for decades of cellar age.'
            </Typography> */}




            {/* <Typography>


            In 1900, when Georges de Latour's wife, Fernande, first laid eyes on the land that would become their original Rutherford vineyard, she named it "beau lieu," or "beautiful place." Shortly thereafter, de Latour sold his thriving cream of tartar business, bought the four-acre ranch and founded Beaulieu Vineyard with the vision of making Napa Valley wines that would rival those of his native France.De Latour quickly made a name for himself by importing Phylloxera-resistant rootstock from Europe to the recently-ravaged fledgling California wine industry. He also began selling wine to the Catholic Church, establishing a strong relationship that would allow Beaulieu Vineyard to become the only Napa Valley winery to remain in business during Prohibition.In fact, during Prohibition the winery increased its business. After the repeal in 1933, de Latour began searching for someone who could contribute European winemaking expertise. In 1938, he traveled to France and returned with André Tchelistcheff, famed viticulturist and enologist who instituted the philosophy of continuous innovation in vineyard and winery to which we remain dedicated today. Tchelistcheff introduced cold fermentation for white wines, malolactic fermentation for reds and aging red wines in small, French oak barrels. He also tasted the de Latour family's private wine-what they called "Private Reserve"-from the 1936 vintage. This Cabernet Sauvignon-based wine was so distinctive that Tchelistcheff insisted it be bottled and sold as the winery's flagship offering. The result was the inaugural release of Georges de Latour Private Reserve Cabernet Sauvignon, a wine that was destined to become Napa Valley's first "cult" Cabernet.Today we continue to turn to innovative practices to craft wines in our bold, classic style. We have become a leader in clonal research, and our BV Clone Reserve Cabernet Sauvignon wines are highly acclaimed. Most recently we completed a new state-of-the-art winery within one of our original buildings. The Georges de Latour Private Reserve Winery utilizes the latest technology in combination with time-honored traditions for the production of this exceptional, wine-the longtime benchmark of Rutherford Cabernet.#1 wine for 2022
            
            
            </Typography> */}




            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}>

                {/* <button
                    onClick={closeModal}
                    style={{
                        opacity: '90%',
                        backgroundColor: '#ccdde8',
                        color: '#034488', //'rgb(171,18,57)', //'maroon',
                        fontSize: '1.3rem',
                        padding: '0.5rem',
                        padding: '1rem',
                        margin: '0.5rem',
                        border: '0rem',
                        fontWeight: 'bold',
                        width: '90%',
                    }}
                >MORE DETAILS
                </button> */}

                <button
                    onClick={closeModal}
                    style={{
                        opacity: '90%',
                        backgroundColor: MODAL_BUTTON_COLOR, // '#011552', // '#ccdde8',
                        color: 'white', // '#034488', //'rgb(171,18,57)', //'maroon',
                        fontSize: '1.1rem',
                        // fontSize: '1.3rem',
                        padding: '0.5rem',
                        padding: '1rem',
                        margin: '0rem',
                        border: '0rem',
                        fontWeight: 'bold',
                        width: '100%',
                        color: PAGE_BUTTON_TEXT_COLOR,
                    }}
                >CLOSE IMAGE
                </button>

            </div>




































        </div >
    );
};

export default ModalContents;























































// <div
// style={{
//     height: '100%',
//     //minHeight: '1300px',
//     width: '45%',//'60rem',
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "space-evenly",


//     paddingBottom: '0rem',
//     paddingTop: '0rem',
//     paddingLeft: '1rem',
//     paddingRight: '0rem',
// }}
// >

// {/* <div
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'row',
//                     justifyContent: 'space-between',
//                 }}
//             > */}


// <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', }}>TYPE: </Typography>
// <Typography sx={{ fontSize: '1rem', fontWeight: 'bold', color: 'black' }}> {wineDetails.type}</Typography>


// {/* </div> */}


// {/* <div
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'row',
//                     justifyContent: 'space-between',
//                 }}
//             > */}


// <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', }}>REGION:</Typography>
// <Typography sx={{ fontSize: '1rem', fontWeight: 'bold', color: 'black' }}>{wineDetails.country_or_domestic_state},</Typography>

// <Typography sx={{ fontSize: '1rem', fontWeight: 'bold', color: 'black' }}>{wineDetails.region}</Typography>


// {/* </div> */}


// {/* 
//             <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', }}>LOCATION:</Typography>
//              */}





// <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', }}>VARIETAL:</Typography>
// <Typography sx={{ fontSize: '1rem', fontWeight: 'bold', color: 'black', paddingBottom: '1rem', }}>{wineDetails.grape}</Typography>














// <div
//     style={{
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//     }}
// >
//     <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', }}>LIGHT / FULL BODY </Typography>
//     <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', color: 'black', }}>{wineDetails.body_light_full}</Typography>


// </div>
// <div className="graph-container">
//     <div className="graph-row">
//         <div className="graph-bar" style={{ '--progress': scorePercentObject.body_light_full }}></div>
//     </div>
// </div>




// <div
//     style={{
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//     }}
// >
//     <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', }}>TANNIN</Typography>
//     <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', color: 'black', }}>{wineDetails.tannin_low_high}</Typography>
// </div>
// <div className="graph-container">
//     <div className="graph-row">
//         <div className="graph-bar" style={{ '--progress': scorePercentObject.tannin_low_high }}></div>
//     </div>
// </div>


// <div
//     style={{
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//     }}
// >
//     <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', }}>DRY / SWEET</Typography>
//     <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', color: 'black', }}>{wineDetails.dry_sweet}</Typography>
// </div>
// <div className="graph-container">
//     <div className="graph-row">
//         <div className="graph-bar" style={{ '--progress': scorePercentObject.dry_sweet }}></div>
//     </div>
// </div>


// <div
//     style={{
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//     }}
// >
//     <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', }}>ACIDITY</Typography>
//     <Typography sx={{ fontSize: '0.8rem', fontWeight: 'bold', color: 'black', }}>{wineDetails.acid_low_high}</Typography>
// </div>
// <div className="graph-container">
//     <div className="graph-row">
//         <div className="graph-bar" style={{ '--progress': scorePercentObject.acid_low_high }}></div>
//     </div>
// </div>















// <Typography sx={{ fontSize: '1rem', fontWeight: 'bold', paddingTop: '1rem', }}>FLAVOR NOTES:</Typography>






// {tastingNotesArray.map((item, index) => (

//     <Typography

//         sx={{
//             fontSize: '1rem',
//             fontWeight: 'bold',
//             color: 'black',
//             padding: '0px',
//             margin: '0px',
//         }}

//         key={`tasting_note-${index}`}

//     >
//         {item}
//     </Typography>

// ))}


// </div>





